import { PipeTransform } from '@angular/core';
import { palantirLabelColorsMap } from './labels.type';
var LabelsPipe = /** @class */ (function () {
    function LabelsPipe() {
    }
    LabelsPipe.prototype.transform = function (value) {
        return palantirLabelColorsMap[value];
    };
    return LabelsPipe;
}());
export { LabelsPipe };
